<div class="modal-header">
  <h4 class="modal-title pull-left"> Change Password </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <page-change-password
    [user]="user"
    (onCreate)="onConfirm()"
    (onCancel)="onCancel()">
  </page-change-password>
</div>
